import * as React from 'react';

import { Libp2pContext } from './Libp2pContext';
import type { Libp2pContextValue } from './types';

export function useLibp2p(): Libp2pContextValue {
  const ctx = React.useContext(Libp2pContext);
  if (!ctx) {
    throw new Error('useLibp2p must be used within a Libp2pProvider');
  }
  return ctx;
}
